import { EventEmitter, Injectable } from "@angular/core";
import { ApiDataService } from "@services/http/ApiDataService";
import { Observable, firstValueFrom } from "rxjs";
import { CalendarModel } from "../models/CalendarModel";
import { CalendarSettingsModel } from "../models/CalendarSettingsModel";

@Injectable()
export class CalendarDataService extends ApiDataService {
    calendarModel: CalendarModel;
    onReload = new EventEmitter<CalendarModel>();

    constructor() {
        super("calendar");
        this.delayedCalenderLoad();
    }

    loadCalendar() {
        this.calendarModel = null;
        firstValueFrom(this.get<CalendarModel>()).then((model) => {
            this.calendarModel = model;
            this.onReload.emit(model);
        });
    }

    getSettings(): Observable<CalendarSettingsModel> {
        const url = this.actionUrl + "/settings";
        return this.http.get<CalendarSettingsModel>(url);
    }

    storeSettings(settings: CalendarSettingsModel) {
        const url = this.actionUrl + "/settings";
        return this.http.post(url, settings);
    }

    /** We implemented this method, so calendar only starts loading after 5s. This makes sure the calendar is only retrieved after all other priority calls have been queued. */
    private delayedCalenderLoad() {
        setTimeout(() => {
            if (!this.calendarModel) {
                this.loadCalendar();
            }
        }, 5000);
    }
}
